import { Outlet } from "react-router-dom";
import { SettingsNav } from "./SettingsNav";
import React from "react";

export function SettingsLayout() {
  return (
    <div className="container max-w-6xl py-8">
      <h1 className="text-3xl font-bold mb-8">Settings</h1>
      <SettingsNav />
      <div className="mt-8">
        <Outlet />
      </div>
    </div>
  );
}